import { FC } from 'react';

type Props = {
};

const OverviewPage: FC<Props> = () => {
    return <div></div>
}

export default OverviewPage;